import { ApplicationContext } from '@varos/client-base';
import { assert } from '@varos/util-typescript';
import { AssistantLoaderBaseConfig } from '../../base';
import { AssistantLinkLoader } from './interviewLinkInterface';
import { AssistantLinkAggregate } from './interviewLinkModel';

export function createLinkLoader(config: AssistantLoaderBaseConfig): AssistantLinkLoader {
    const {
        kernel,
        repository: { session, accept },
        adapter,
    } = config;

    return {
        useLoad(context, props): AssistantLinkAggregate {
            const acceptQuery = accept.useLookup(
                context,
                {
                    token: props.token,
                },
                { suspense: true }
            );
            assert(acceptQuery.status === 'success', 'expected suspense');
            return {
                accept: acceptQuery.data,
            };
        },
    };
}
